import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Button,
  Alert,
  CardHeader,
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import makeAnimated from 'react-select/lib/animated';
import Select1 from 'react-select';
import { Select, Textbox, Radiobox, Checkbox } from "react-inputs-validation";
import "../../../styles/estilos.css";
import '../../../styles/_base.scss'
import {ProvinciasPymesFetch} from "../../../redux/actions/aRamoPymes";


class CotizacionPymes2Diners extends React.Component {
  constructor(props) {
    super(props);
    const { provincias, tipoConstruccion, data, volverResumen } = this.props;

    const modeloprotecciones = [
      { codigo: "roceadores", name: "Sprinklers/Roceadores", value: false },
      { codigo: "extintores", name: "Extintores", value: false },
      {
        codigo: "hidrantes",
        name: "Hidrantes Interiores/Exteriores",
        value: false,
      },
      { codigo: "detectoreshumo", name: "Detectores de Humo", value: false },
      {
        codigo: "bombacontrahincendios",
        name: "Bomba del Sistema Contra Incendio",
        value: false,
      },
      { codigo: "guardias", name: "Guardias de Seguridad", value: false },
      { codigo: "cajafuerte", name: "Caja Fuerte", value: false },
      { codigo: "alarma", name: "Alarma", value: false },
      { codigo: "alarmamonitoreada", name: "Alarma Monitoreada", value: false },
      { codigo: "aguapublico", name: "Público", value: false },
      { codigo: "aguaprivado", name: "Privado", value: false },
    ];
    //const { anioconstruccion: anio, ciudad, ciudadSelect: canton, pisos, provSelect: provincia, tipoConselect: tipoconstruccion } = this.state;
    if (data) {
      const {
        anio: anioconstruccion,
        canton: ciudadSelect,
        ciudad,
        pisos,
        provincia: provSelect,
        tipoconstruccion: tipoConselect,
        protecciones,
        direccion,
      } = data;
      this.state = {
        validate: false,
        anioconstruccion,
        ciudad,
        pisos,
        ciudadSelect,
        provSelect,
        tipoConselect,
        direccion,
        alert: "",
        protecciones,
      };
    } else {
      const { id: id2 = "" } = provincias[0];
      this.state = {
        validate: false,
        ciudadSelect: "",
        tipoConselect: "",
        provSelect: id2,
        hasCiudadError: true,
        hasPisosError: true,
        accion: "nuevo",
        alert: "",
        direccion: "",
        protecciones: modeloprotecciones,
      };
    }
  }

  async componentDidMount() {
    const { provSelect } = this.state;
    const { ProvinciasPymesFetch, getCiudades, limites } = this.props;

    // Llamar al servicio
    if (ProvinciasPymesFetch) {
      ProvinciasPymesFetch("pymesDiners");
    }

    // Cargar ciudades si ya hay provincia
    if (provSelect && getCiudades) {
      getCiudades(provSelect);
    }

    // Activar validación si no hay datos previos
    if (!this.props.data) {
      setTimeout(() => {
        this.setState({ validate: true });
      }, 500);
    }


  }


  componentDidUpdate(prevProps, prevState) {
    if (
        this.props.ciudades !== prevProps.ciudades &&
        this.props.ciudades.length > 0
    ) {
      if (!(this.props.data && prevProps.ciudades.length === 0))
        this.setState({ ciudadSelect: this.props.ciudades[0].id });
    }

    if (
        prevProps.limites !== this.props.limites &&
        this.props.limites.length > 0
    ) {
      let limiteanio = 1900;
      let limitePisos = 100;

      this.props.limites.forEach((element) => {
        if (element.codigo === "minAnio") limiteanio = element.limite;
        if (element.codigo === "maxPisos") limitePisos = element.limite;
      });

      this.setState({ limiteanio, limitePisos });
    }
  }


  onClick = () => {
    const {
      hasAnoConstError,
      hasCantonError,
      hasCiudadError,
      hasPisosError,
      hasProvinciaError,
      hasTipoConstError,
      hasDireccionError,
      ciudadSelect,
    } = this.state;

    if (
      !hasAnoConstError &&
      (!hasCantonError || ciudadSelect !== "" || ciudadSelect !== undefined) &&
      !hasCiudadError &&
      !hasPisosError &&
      !hasProvinciaError &&
      !hasTipoConstError &&
      !hasDireccionError
    ) {
      const {
        anioconstruccion: anio,
        ciudad,
        ciudadSelect: canton,
        pisos,
        provSelect: provincia,
        tipoConselect: tipoconstruccion,
        protecciones,
        direccion,
      } = this.state;
      const data = {
        anio,
        ciudad,
        canton,
        pisos,
        provincia,
        tipoconstruccion,
        protecciones,
        direccion,
      };

      this.props.guardarUbicacion(
        data,
        this.props.NumUbicacion - 1,
        this.props.volverResumen,
      );

    } else {
      this.setState({ alert: "Complete el formulario para continuar" });

      setTimeout(() => this.setState({ alert: "" }), 3000);
    }
  };

  render() {
    const {
      validate,
      ciudad,
      anioconstruccion,
      pisos,
      ciudadSelect,
      tipoConselect = "",
      provSelect,
      limiteanio = "",
      limitePisos = "",
      alert,
      direccion,
      protecciones,
    } = this.state;
    const {
      handleNext,
      provincias,
      limites,
      tipoConstruccion,
      getCiudades,
      ciudades,
      handleBack,
    } = this.props;

    // Corregir el input recibido desde el servidor para el componente Select1
    // Para lista de provincias o cantones
    const listSlct1 = (list) => { 
      const formatList = []
      for (const idx in list){
        formatList.push({
          value: list[idx].id,
          label: list[idx].name
        })
      }
      // return
      return formatList
    }
    // Para provincia o canton especifica
    const itemSlct1 = (item, list) => {
      const formatItem = {}
      const typeItem =typeof(item)
      // Al inicio llega un string con el id de la ciudad del servicio, para provincias
      if(typeItem === 'string'){
        formatItem['value'] = item
        for (const idx in list){
          if(list[idx].id === item){
            formatItem['label'] = list[idx].name
          }
        }
      }
      // Siguientes veces, llega un objecto con id de provincia o canton como campo
      else if (typeItem === 'object'){
        formatItem['value'] = item.id
        formatItem['label'] = item.name
      } else{ console.error('La respuesta del servicio para las ciudades, no es correcta')}
      // return
      return formatItem
    }

    const anio = new Date().getFullYear();
    const { NumUbicacion } = this.props;
    return (
      <Row>
        <Col xl={8} lg={10} md={11} className="div-align-center">
          <Card>
            <CardHeader>
              {" "}
              <h4 style={{ fontWeight: "bold" }} className="mb-2">
                Ubicación {NumUbicacion}
              </h4>
            </CardHeader>
            <CardBody>
              {/* <h4 style={{ fontWeight: 'bold', }} className='mb-5'>Ubicación {NumUbicacion}</h4> */}
              <Col className="div-align-center" style={{}}>
                <Row className="mb-3">
                  <Col md={4}>
                    <h5>
                      <Label className="bold-font-label">
                        Tipo de construcción{" "}
                      </Label>
                    </h5>
                  </Col>
                  <Col md={8}>
                    <p style={{ fontWeight: "normal" }}>
                      La estructura, los techos, muros y/o las paredes de esta
                      ubicación tiene(n) el (los) siguiente(s) material(es):
                    </p>
                    <Radiobox
                      //tabIndex={2} // Optional.[String or Number].Default: none.
                      id={`tipoConstruccion-${NumUbicacion}`} // Optional.[String].Default: "".  Input ID.
                      name="tipoConstruccion" // Optional.[String].Default: "". Input name.
                      value={tipoConselect} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={tipoConstruccion}
                      customStyleContainer={{
                        display: "block",
                        justifyContent: "center",
                      }} // Optional.[Object].Default: {}.
                      customStyleOptionListItem={{
                        width: "100%",
                        position: "static",
                        opacity: "100",
                        display: "block",
                      }} // Optional.[Object].Default: {}.
                      onChange={(tipoConselect, e) => {
                        console.log(tipoConselect);
                        this.setState({
                          tipoConselect,
                          hasTipoConstError: false,
                        });
                      }}
                      validationCallback={(res) =>
                        this.setState({ hasTipoConstError: res })
                      }
                      // Required.[Func].Default: () => {}. Will return the value.
                      onBlur={(e) => {}} // Optional.[Func].Default: none.
                      validationOption={{
                        name: "tipoConstruccion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione una opción", // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                    {tipoConselect === "D" && (
                      <Alert color="warning">
                        {" "}
                        Para este tipo de construcción, por favor comunicarse
                        con un ejecutivo de AIG Metropolitana{" "}
                      </Alert>
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5 style={{ margin: 0 }}>
                      <Label className="bold-font-label">Ciudad</Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="input"
                      value={ciudad}
                      name="ciudad"
                      id={`"ciudad-${NumUbicacion}`}
                      classNameInput={"form-control"}
                      onChange={(ciudad, e) => {
                        this.setState({
                          ciudad: ciudad,
                          hasCiudadError: false,
                        });
                      }}
                      validate={validate}
                      validationCallback={(res) =>
                        this.setState({ hasCiudadError: res })
                      }
                      // Optional.[Func].Default: none. Return the validation result.
                      validationOption={{
                        name: "ciudad", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true,
                        reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                        msgOnError: "Por favor ingrese una ciudad", // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5>
                      <Label className="bold-font-label">Provincia</Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>
                    
                    {/* Dropdown para Provincias */}
                    <Select1
                    options={listSlct1(provincias)}
                    value = {itemSlct1(provSelect, provincias)}
                    // components={makeAnimated()}
                    onChange={
                      (provSelect, e) => {
                        // se manda value o id de ciudad para actualizar estado 
                        provSelect = provSelect.value
                        this.setState({ provSelect });
                        getCiudades(provSelect);
                      }
                    }
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5>
                      <Label className="bold-font-label">Cantón</Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>

                  {/* Dropdown Canton */}
                  <Select1
                    options={listSlct1(ciudades)}
                    value = {itemSlct1(ciudadSelect, ciudades)}
                    // components={makeAnimated()}
                    onChange={
                      (ciuSelect, e) => {
                        // se manda value o id de ciudad para actualizar estado 
                        ciuSelect = ciuSelect.value
                        this.setState({ ciudadSelect: ciuSelect });
                      }
                    }
                    />

                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5>
                      <Label className="bold-font-label">Dirección</Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="input"
                      value={direccion}
                      name="direccion"
                      id={`"direccion-${NumUbicacion}`}
                      classNameInput={"form-control"}
                      onChange={(direccion, e) => {
                        this.setState({ direccion, hasDireccionError: false });
                      }}
                      onBlur={() => this.setState({ validate: true })}
                      validate={validate}
                      validationCallback={(res) =>
                        this.setState({ hasDireccionError: res })
                      }
                      // Optional.[Func].Default: none. Return the validation result.
                      validationOption={{
                        name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        reg: /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,-]*$/,
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor ingrese una dirección, no debe tener caracteres especiales"
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5 style={{ margin: "0px" }}>
                      <Label className="bold-font-label">
                        Año de Construcción
                      </Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>
                    {/*console.log("limiteanio:", limiteanio)*/}
                    <Textbox
                      id="anioconstruccion"
                      name="anioconstruccion"
                      type="number"
                      value={anioconstruccion}
                      classNameInput={"form-control"}
                      onChange={(anioconstruccion, e) =>
                        this.setState({ anioconstruccion })
                      }
                      validate={validate}
                      onBlur={(e) => {}}
                      validationCallback={(res) =>
                        this.setState({ hasAnoConstError: res })
                      } // Optional.[Func].Default: none. Return the validation result.
                      validationOption={{
                        name: "anioconstruccion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true,
                        type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                        min: limiteanio, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                        max: anio,
                        msgOnError: `Se aceptan riesgos construidos desde 1990. Para riesgos construidos antes de 1990 por favor comunicarse con un ejecutivo de AIG Metropolitana`, // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={12} md={12} sm={12} xs={12} className="ml-3">
                    <p style={{ fontWeight: 500 }}>
                      Ingresar el número total de pisos del edificio o ubicación
                      donde esta el riesgo y no el piso donde opera el cliente
                    </p>
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                    <h5 style={{ margin: 0 }}>
                      <Label className="bold-font-label">Número de pisos</Label>
                    </h5>
                  </Col>
                  <Col lg={7} md={7} sm={12} xs={12}>
                    <Textbox
                      tabIndex="1"
                      type="number"
                      value={pisos}
                      name="pisos"
                      id="pisos"
                      classNameInput={"form-control"}
                      onChange={(pisos, e) =>
                        this.setState({ pisos: pisos, hasPisosError: false })
                      }
                      onBlur={() => {}}
                      validate={validate}
                      validationCallback={(res) =>
                        this.setState({ hasPisosError: res })
                      }
                      // Optional.[Func].Default: none. Return the validation result.
                      validationOption={{
                        name: "pisos", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true,
                        type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                        min: 1, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                        max: limitePisos,
                        msgOnError:
                          "Por favor ingrese el numero de pisos debe ser de 1 a " +
                          limitePisos, // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}
                    />
                  </Col>
                </Row>

                <Row className="mb-3 ml-3">
                  <Col md={12}>
                    <h5>
                      <Label for="SelectCiudad" className="bold-font-label">
                        Protecciones
                      </Label>
                    </h5>
                  </Col>
                </Row>
                <Row className="ml-5">
                  {protecciones &&
                    protecciones.map(
                      ({ codigo, name, value }, i) =>
                        i < 7 && (
                          <Col md={12} className="mb-0">
                            <Checkbox
                              attributesInput={{
                                // Optional.
                                id: "agreement",
                                name: "agreement",
                              }}
                              value={name} // Required.[String].Default: "".
                              onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              checked={value} // Required.[Bool].Default: false.
                              onChange={(val, e) => {
                                let { protecciones } = this.state;
                                protecciones[i] = {
                                  ...protecciones[i],
                                  value: val,
                                };
                                this.setState({ protecciones });
                                console.log(protecciones, val);
                              }} // Required.[Func].Default: () => {}. Will return the value.
                              labelHtml={
                                <div
                                  style={{ color: "#4a4a4a", marginTop: "2px" }}
                                >
                                  {name}
                                </div>
                              } // Required.[Html].Default: none.
                              // validationOption={{
                              //   name: 'agreement', // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                              //   check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              //   required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              // }}
                            />
                          </Col>
                        )
                    )}
                  {protecciones && (
                    <>
                      <Col md={5} className="mb-0">
                        <Checkbox
                          attributesInput={{
                            // Optional.
                            id: "agreement",
                            name: "agreement",
                          }}
                          value={protecciones[7].name} // Required.[String].Default: "".
                          onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={protecciones[7].value} // Required.[Bool].Default: false.
                          onChange={(val, e) => {
                            let { protecciones } = this.state;
                            if (val) {
                              protecciones[8] = {
                                ...protecciones[8],
                                value: false,
                              };
                            }
                            protecciones[7] = {
                              ...protecciones[7],
                              value: val,
                            };
                            this.setState({ protecciones });
                            console.log(protecciones, val);
                          }}
                          labelHtml={
                            <div style={{ color: "#4a4a4a", marginTop: "2px" }}>
                              {protecciones[7].name}
                            </div>
                          } // Required.[Html].Default: none.
                          // validationOption={{
                          //   name: 'agreement', // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          //   check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          //   required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          // }}
                        />
                      </Col>
                      <Col md={5} className="mb-0">
                        <Checkbox
                          attributesInput={{
                            // Optional.
                            id: "agreement",
                            name: "agreement",
                          }}
                          value={protecciones[8].name} // Required.[String].Default: "".
                          onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={protecciones[8].value} // Required.[Bool].Default: false.
                          onChange={(val, e) => {
                            let { protecciones } = this.state;
                            if (val) {
                              protecciones[7] = {
                                ...protecciones[7],
                                value: false,
                              };
                            }
                            protecciones[8] = {
                              ...protecciones[8],
                              value: val,
                            };
                            this.setState({ protecciones });
                            console.log(protecciones, val);
                          }}
                          labelHtml={
                            <div style={{ color: "#4a4a4a", marginTop: "2px" }}>
                              {protecciones[8].name}
                            </div>
                          } // Required.[Html].Default: none.
                          // validationOption={{
                          //   name: 'agreement', // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          //   check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          //   required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          // }}
                        />
                      </Col>
                      <Col md={12}>
                        <div style={{ color: "#4a4a4a", marginTop: "2px" }}>
                          Suministro de agua:
                        </div>
                      </Col>
                      <Col md={5} className="mb-0">
                        <Checkbox
                          attributesInput={{
                            // Optional.
                            id: "agreement",
                            name: "agreement",
                          }}
                          value={protecciones[9].name} // Required.[String].Default: "".
                          onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={protecciones[9].value} // Required.[Bool].Default: false.
                          onChange={(val, e) => {
                            let { protecciones } = this.state;
                            if (val) {
                              protecciones[10] = {
                                ...protecciones[10],
                                value: false,
                              };
                            }
                            protecciones[9] = {
                              ...protecciones[9],
                              value: val,
                            };
                            this.setState({ protecciones });
                            console.log(protecciones, val);
                          }}
                          labelHtml={
                            <div style={{ color: "#4a4a4a", marginTop: "2px" }}>
                              {protecciones[9].name}
                            </div>
                          } // Required.[Html].Default: none.
                          // validationOption={{
                          //   name: 'agreement', // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          //   check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          //   required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          // }}
                        />
                      </Col>
                      <Col md={5} className="mb-0">
                        <Checkbox
                          attributesInput={{
                            // Optional.
                            id: "agreement",
                            name: "agreement",
                          }}
                          value={protecciones[10].name} // Required.[String].Default: "".
                          onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={protecciones[10].value} // Required.[Bool].Default: false.
                          onChange={(val, e) => {
                            let { protecciones } = this.state;
                            if (val) {
                              protecciones[9] = {
                                ...protecciones[9],
                                value: false,
                              };
                            }
                            protecciones[10] = {
                              ...protecciones[10],
                              value: val,
                            };
                            this.setState({ protecciones });
                            console.log(protecciones, val);
                          }}
                          labelHtml={
                            <div style={{ color: "#4a4a4a", marginTop: "2px" }}>
                              {protecciones[10].name}
                            </div>
                          } // Required.[Html].Default: none.
                          // validationOption={{
                          //   name: 'agreement', // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          //   check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          //   required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          // }}
                        />
                      </Col>
                    </>
                  )}
                </Row>

                <Row>
                  <Col sm={12}>
                    {" "}
                    {alert && (
                      <Alert md={12} color="warning">
                        {" "}
                        {alert}{" "}
                      </Alert>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} className="mt-3">
                    <Button
                      className="btn btn-detail-gray"
                      onClick={() => handleBack(1)}
                      style={{ display: "block", margin: "auto" }}
                      disabled={
                        this.props.volverResumen
                          ? this.props.volverResumen
                          : false
                      }
                    >
                      <i
                        className="fa fa-chevron-circle-left"
                        aria-hidden="true"
                      />
                      {"   REGRESAR"}
                    </Button>
                  </Col>
                  <Col xs={6} className="mt-3">
                    <div className="div-align-rigth">
                      <Button
                        className="btn btn-primary"
                        disabled={tipoConselect === "D"}
                        onClick={() => {
                          this.setState({ validate: true });
                          this.onClick();
                        }}
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        />
                        {` SIGUIENTE UBICACIÓN`} {/* ${NumUbicacion} */}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  provincias: state.dataPymes.provincias,
  limites: state.dataPymes.limites,
  tipoConstruccion: state.dataPymes.tiposConstruccion,
});
const mapDispatchToProps = (dispatch) => ({
  ProvinciasPymesFetch: (codProducto) => dispatch(ProvinciasPymesFetch(codProducto)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CotizacionPymes2Diners));
